import type { StorageSasGrant } from '../../../../../types/azureStorage';
import { parseConnectionString } from '../../../../connections/services/connection-string/parseConnectionString';
import { useConnectionStringPrefillStore } from '../../../../connections/store/connectionStringPrefillStore';
import { useConnectionsUIStore } from '../../../../connections/store/uiStore';

/**
 * S8 (Task 8.7): a directory SAS is handed out as its DFS URL (D7), but an attachment dials the account's BLOB endpoint
 * (every Blob-API surface — listing, download, upload — and the Data Lake port derives its dfs host from the account,
 * the same `<acct>.dfs.` ⇄ `<acct>.blob.` host mapping the SDK uses — residual R7). `sr=d` keeps it a single-resource
 * `hnsPath` attachment either way.
 */
function attachUrlOf(grant: StorageSasGrant): string {
  if (grant.resource.kind !== 'hnsPath') return grant.url;
  return grant.url.replace(/^(https:\/\/[^/.]+)\.dfs\./iu, '$1.blob.');
}

export function addSasAsConnection(grant: StorageSasGrant): string {
  const input = grant.connectionString ?? attachUrlOf(grant);
  const result = parseConnectionString(input);
  if (result.outcome === 'failed') throw new Error('The generated SAS could not be mapped to a connection form.');
  const handoffId = useConnectionStringPrefillStore.getState().begin({ result, input });
  useConnectionsUIStore.getState().setShowNewConnectionDialog(true, handoffId);
  return handoffId;
}
